import moment from "moment";
import React, { forwardRef, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useRecoilValue } from "recoil";
import { getRecoil, setRecoil } from "recoil-nexus";
import RejectConfirmModal from "../../../components/modal/RejectConfirmModal";
import RejectModal from "../../../components/modal/RejectModal";
import RiderRejectModal from "../../../components/modal/RiderRejectModal";
import ApiController from "../../../controller/ApiController";
import OrderController, {
  OrderStatusType,
} from "../../../controller/OrderController";
import { useToast } from "../../../controller/ToastController";
import {
  CurrentStoreType,
  authState,
  currentStoreState,
} from "../../../recoil/auth";
import { deliverySettingState } from "../../../recoil/delivery";
import {
  KnockOrderItemType,
  ORDER_CANCLE_STATUS,
  ORDER_COM_DEL_STATUS,
  ORDER_COM_STATUS,
  ORDER_READY_STATUS,
  ORDER_WAIT_STATUS,
  SoldoutMenuType,
} from "../../../recoil/type";
import OrderDetails from "./Info/OrderDetails";
import OrderInfo from "./Info/OrderInfo";
import { KnockOrderStyle } from "./OrderStyle";
import { chatFinishedState, newChatListState } from "../../../recoil/chat";
import LogController from "../../../controller/LogController";
import SoldoutModal from "../../../components/modal/SoldoutModal";
import CouponModal from "../../../components/modal/CouponModal";

type OrderProps = {
  order: KnockOrderItemType;
  detailStatus: boolean;
  index: number;
};

const KnockOrder = forwardRef<HTMLDivElement, OrderProps>(
  ({ order, detailStatus, index }, ref) => {
    const currentStore = useRecoilValue<CurrentStoreType>(currentStoreState);

    const [isDetail, setIsDetail] = useState<boolean>(detailStatus);
    const [isCopy, setIsCopy] = useState<boolean>(false);

    const [isBlink, setIsBlink] = useState<boolean>(false);
    const [blinkCount, setBlinkCount] = useState<number>(
      currentStore.value &&
        currentStore.value.auto_confirmed === 1 &&
        order.child.order_status === ORDER_READY_STATUS
        ? 3
        : 0
    );

    const deliverySetting = useRecoilValue(deliverySettingState);

    const [visibleReject, setVisibleReject] = useState<boolean>(false);
    const [visibleSoldout, setVisibleSoldout] = useState<boolean>(false);
    const [visibleConfirm, setVisibleConfirm] = useState<boolean>(false);

    const [visibleRejectRider, setVisibleRejectRider] = useState<{
      visible: boolean;
      msg: string;
    }>({
      visible: false,
      msg: "",
    });

    const [type, setType] = useState<string>("가게 사정");
    const [soldoutMenu, setSoldoutMenu] = useState<SoldoutMenuType[]>([]);

    const chatFinishedFlag = useRecoilValue<boolean>(chatFinishedState);

    let interval: NodeJS.Timeout;

    const stopBlink = (interval: any) => {
      clearInterval(interval);
      setIsBlink(false);
    };

    const checkRiderCancel = async (isForce: boolean) => {
      console.log("devlisettg", deliverySetting, order.child.delivery_type);
      LogController.click({
        path: "cancel Button",
        params: "주문 취소 최종 클릭",
        params2: order.order_id,
      });
      if (
        deliverySetting.type === "barogo" &&
        deliverySetting.mode === 1 &&
        order.child.delivery_type === 0
      ) {
        const riderCancelled = await cancelRider();
        if (riderCancelled === 1) return;
        else {
          if (riderCancelled === 2) {
            cancelStatus();
            LogController.delivery({
              path: "OrderCancel",
              params: "바로고 취소 성공",
              params2: order.order_id,
            });
          } else {
            if (isForce) {
              cancelStatus();
              LogController.delivery({
                path: "OrderCancel",
                params: "바로고 강제 취소",
                params2: order.order_id,
              });
            } else {
              setVisibleConfirm(false);
              setVisibleRejectRider({
                visible: true,
                msg: "배달접수 프로그램을 확인해주세요",
              });
              LogController.delivery({
                path: "OrderCancel",
                params: "바로고 취소 불가 상태",
                params2: order.order_id,
              });
            }
          }
        }
      } else {
        cancelStatus();
      }
    };

    // 바로고 취소
    const cancelRider = async () => {
      try {
        const oParams = {
          store_id: order.store_id,
          order_id: order.order_id,
          cancel_type: "CANCEL_BY_STORE",
          cancel_reason: type,
        };
        const oRes = await ApiController.delivery.cancel(oParams);
        if (oRes && oRes.data) {
          const oResponse = oRes.data;
          if (oResponse.ok) {
            if (oResponse.data.success) {
              return 2;
            } else {
              if (oResponse.data.message) {
                toast.error(oResponse.data.message);
                LogController.delivery({
                  path: "OrderCancel",
                  params: oResponse.data.message,
                  params2: order.order_id,
                });
              }
              return 1;
            }
          } else {
            toast.error("배달 연동에 실패했어요");
            return 0;
          }
        }
      } catch (e) {
        console.error("err => ", e);
        return 0;
      }
    };

    // orderStatus API
    const cancelStatus = async () => {
      const oParams: OrderStatusType = {
        order_id: order.order_id,
        order_seq: order.child.order_seq,
        order_status: 4,
        table_area_nr: order.table_area_nr,
        table_nr: order.table_nr,
        store_id: order.store_id,
        parent_store_id: order.parent_store_id,
        cancel_description: type,
        user_token_id: getRecoil(authState).user_token_id,
        status_changed_at: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      };

      //return;
      console.log("oParams", oParams);
      const oRes = await OrderController.updateStatus(oParams);

      if (oRes && oRes.data) {
        setVisibleReject(false);
        setVisibleConfirm(false);
        if (type === "재료 소진" && soldoutMenu.length > 0) {
          setSoldout();
        }
      }
    };

    const setSoldout = async () => {
      try {
        const oParams = {
          sold_out: soldoutMenu,
        };

        const response = await OrderController.setSoldout(oParams);

        if (response && response.data) {
          const oRes = response.data;
          if (oRes.data && oRes.data.success) {
            toast.success("선택한 메뉴를 품절처리했어요");
          }
        }
      } catch (err) {
        console.log("err-->", err);
      }
    };

    const checkReject = () => {
      setVisibleReject(false);
      if (type === "재료 소진") {
        setVisibleSoldout(true);
      } else setVisibleConfirm(true);
    };

    const CheckRejectSoldout = () => {
      setVisibleSoldout(false);
      setVisibleConfirm(true);
    };

    const checkProcessingOrder = () => {
      if (
        order.child.order_status !== ORDER_CANCLE_STATUS &&
        order.child.order_status !== ORDER_COM_DEL_STATUS &&
        order.child.order_status !== ORDER_COM_STATUS
      )
        return true;
      else return false;
    };

    // 깜빡이
    useEffect(() => {
      const startBlink = () => {
        interval = setInterval(() => {
          setIsBlink((prevState) => !prevState);
        }, 600);
      };

      if (blinkCount === 0 && order.child.order_status !== ORDER_WAIT_STATUS) {
        stopBlink(interval!);
      } else {
        startBlink();
      }

      return () => stopBlink(interval);
    }, [order.child.order_status]);

    useEffect(() => {
      if (isBlink && blinkCount > 0) {
        setBlinkCount(blinkCount - 1);
      }
      if (blinkCount === 0 && order.child.order_status !== ORDER_WAIT_STATUS)
        stopBlink(interval);
    }, [isBlink]);

    // 자세히 보기
    useEffect(() => {
      if (detailStatus !== isDetail) setIsDetail(detailStatus);
    }, [detailStatus]);

    useEffect(() => {
      if (chatFinishedFlag) {
        setRecoil(newChatListState, (prev) => [
          ...prev.filter(
            (item) =>
              !(
                item.order_id === order.order_id &&
                item.order_seq === order.child.order_seq &&
                item.store_id === order.store_id
              )
          ),
        ]);
      }
    }, [chatFinishedFlag]);

    return (
      <>
        <KnockOrderStyle style={{ position: "relative" }}>
          <div className="orderListWrap" ref={ref}>
            {/* 간략한 내용 */}
            <OrderInfo
              order={order}
              isBlink={isBlink}
              isDetail={isDetail}
              index={index}
              setBlinkCount={setBlinkCount}
            />
            {/* 자세히 보기 */}
            {isDetail && (
              <OrderDetails
                order={order}
                isCopy={isCopy}
                deliverySetting={deliverySetting}
                setIsCopy={setIsCopy}
                setVisibleReject={setVisibleReject}
              />
            )}
            <div className="arrowDown" onClick={() => setIsDetail(!isDetail)}>
              <img
                src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_arrow_${
                  isDetail ? "up" : "down"
                }_black.svg`}
                alt="img"
              />
            </div>
          </div>
          {checkProcessingOrder() && order.child.bill_number === "TEST-1" && (
            <div className="testOrder">
              <div className="header">
                <h5>
                  우리 매장 주문 활성화를 위한 테스트 주문입니다. 지금은 주문
                  테스트 중입니다 🤗
                </h5>
              </div>
            </div>
          )}
          {checkProcessingOrder() && order.child.bill_number === "TEST-2" && (
            <div className="testOrder">
              <div className="header">
                <h5>
                  노크노크에 오신 것을 환영합니다! 지금은 첫 주문 테스트
                  중입니다 🤗
                </h5>
              </div>
            </div>
          )}
        </KnockOrderStyle>
        <RejectModal
          isVisible={visibleReject}
          setVisible={setVisibleReject}
          type={type}
          setType={setType}
          setVisibleConfirm={checkReject}
        />
        <RejectConfirmModal
          isVisible={visibleConfirm}
          setVisible={setVisibleConfirm}
          type={type}
          onConfirm={() => checkRiderCancel(false)}
        />
        <RiderRejectModal
          title={"배달 대행 취소에 실패했어요"}
          isVisible={visibleRejectRider}
          setVisible={setVisibleRejectRider}
          onCancel={() => {
            setVisibleRejectRider({ visible: false, msg: "" });
            LogController.click({
              path: "RiderRejectModal cancel Button",
              params: "바로고 취소 보류 클릭",
              params2: order.order_id,
            });
          }}
          cancelComment="보류하기"
          onConfirm={() => checkRiderCancel(true)}
          confirmColor={"#ff3542"}
          confirmComment="주문만 취소하기"
          isRetry={false}
        />
        <SoldoutModal
          isVisible={visibleSoldout}
          setVisible={setVisibleSoldout}
          soldoutMenu={soldoutMenu}
          setSoldoutMenu={setSoldoutMenu}
          order={order}
          setVisibleConfirm={CheckRejectSoldout}
        />
      </>
    );
  }
);

export default KnockOrder;
